import {
  FETCH_ORDER_REFUND_PENDING,
  FETCH_ORDER_REFUND_REJECTED,
  FETCH_ORDER_REFUND_FULFILLED,
  SET_REFUNDED_ORDER_ITEMS,
  FETCH_CANCELLATION_REASONS_PENDING,
  FETCH_CANCELLATION_REASONS_FULFILLED
} from "../constants/orderRefund";

const initialState = {
  pending: false,
  cancellationReasonsPending: true,
  order: {},
  orderItems: {},
  refundInvoiceNumber: null,
  error: {},
  cancellationReasons: [],
  success: false
};

export const orderRefund = (state = initialState, action) => {
  switch (action.type) {
    case SET_REFUNDED_ORDER_ITEMS:
      return {
        ...state,
        orderItems: action.response.orderItems,
        order: action.response.order,
        refundInvoiceNumber: action.response.refundInvoiceNumber,
        error: {},
        success: false
      };

    case FETCH_ORDER_REFUND_PENDING:
      return { ...state, pending: true, error: [] };

    case FETCH_CANCELLATION_REASONS_PENDING:
      return { ...state, cancellationReasonsPending: true };

    case FETCH_CANCELLATION_REASONS_FULFILLED:
      return {
        ...state,
        cancellationReasonsPending: false,
        cancellationReasons: action.response.results
      };

    case FETCH_ORDER_REFUND_REJECTED:
      return { ...state, pending: false, error: action.error.response.data };

    case FETCH_ORDER_REFUND_FULFILLED:
      return {
        ...state,
        order: action.response,
        pending: false,
        success: true,
        error: []
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/orderRefund.js